module.exports = __webpack_public_path__ + "static/media/9.2962b370.jpg";